/*
  sl-gift-sync — makes the cart match the decisions Liquid hands back: one real
  $0 line per unlocked free gift, and bundle lines kept on their bundle price.

  Checkout is hosted by Shopify and renders only real cart line items, so the
  book covers drawn by snippets/sl-cart-gifts.liquid stop at the cart. Mirroring
  each unlocked gift as a $0 line carries it into checkout, the order and the
  confirmation email.

  This file decides nothing. It asks /cart?view=sl-rules what the cart has earned
  and what should be swapped, then applies the answer. Keeping every rule on the
  Liquid side means the drawn covers and the real lines cannot disagree.

  Every failure path leaves the cart untouched: a shopper never gets blocked from
  checking out because a gift could not be attached.
*/
(function () {
  var configElement = document.getElementById('sl-gift-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }
  if (!config || !Array.isArray(config.gifts) || config.gifts.length === 0) return;

  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var cartUpdateUrl = routes.cart_update_url || '/cart/update';
  var rulesUrl = config.rulesUrl || cartUrl + '?view=sl-rules';
  var syncing = false;

  function quantityInCart(cart, variantId) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === variantId) total += item.quantity;
    });
    return total;
  }

  /* Returns the /cart/update payload, or null when the cart already matches the
     rules — skipping the write keeps this from fighting Dawn's own cart calls.
     Quantities are absolute, so a half-applied earlier run self-corrects, and a
     variant absent from the cart is added rather than ignored, which is what
     turns a swap into a single call.

     Note: Shopify orders cart lines newest-first, so the gifts sit above the
     paid product in the checkout summary. Nothing the theme does changes that —
     /cart/add and re-touching the paid line were both tried. */
  function pendingUpdates(cart, rules) {
    var updates = {};
    var stale = false;

    /* Bundle swaps first: retiring the old line and standing up the bundle one
       are two entries in the same absolute-quantity map. */
    (rules.upgrades || []).forEach(function (swap) {
      updates[swap.from] = 0;
      updates[swap.to] = (updates[swap.to] || 0) + 1;
      stale = true;
    });

    var unlocked = String(rules.unlocked || '').split(',').filter(Boolean);
    config.gifts.forEach(function (gift) {
      var wanted = unlocked.indexOf(gift.key) !== -1 ? 1 : 0;
      if (quantityInCart(cart, gift.variantId) !== wanted) stale = true;
      updates[gift.variantId] = wanted;
    });

    return stale ? updates : null;
  }

  /* Dawn's own re-render. In the drawer it refreshes the lines and the footer
     together, which covers everything a swap changes. The cart page keeps its
     totals in a separate section that Dawn does not re-fetch here, so reload it
     rather than leave a stale subtotal on screen. */
  function redrawCart() {
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      drawerItems.onCartUpdate();
    }
  }

  /* forceRedraw: the caller already changed the cart itself and needs the
     rendered rows refreshed even when the rules turn out to have nothing to add. */
  function sync(forceRedraw) {
    if (syncing) return;
    syncing = true;

    Promise.all([
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      }),
      /* No Accept header: Shopify content-negotiates the storefront routes and
         answers an explicit text/plain or application/json request for this view
         with a 404. */
      fetch(rulesUrl).then(function (r) {
        return r.text();
      }),
    ])
      .then(function (results) {
        var cart = results[0];
        var rules = JSON.parse(results[1].trim());
        var swapped = (rules.upgrades || []).length > 0;
        var updates = pendingUpdates(cart, rules);
        if (!updates) {
          if (forceRedraw) redrawCart();
          return null;
        }

        return fetch(cartUpdateUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (updated) {
            /* Dropping the last paid item leaves the page showing a cart that is
               no longer there — the gifts have just been detached behind it. */
            if (updated.item_count === 0) {
              window.location.reload();
            } else if (swapped || forceRedraw) {
              /* A swap rewrites the line the shopper is looking at — its name and
                 price both change — so the rendered cart has to catch up. Gift
                 lines never need this: they are hidden from both cart surfaces. */
              redrawCart();
            }
          });
      })
      .catch(function () {
        /* Cart stays usable without the gift lines. */
      })
      .then(function () {
        syncing = false;
      });
  }

  /* ---------------------------------------------------------------------
     The bundle stepper.

     On a bundle line the quantity box counts MACHINES, not line items: a
     shopper looking at "Symmetry Pair" sees 2, and stepping to 3 means three
     machines, not three pairs. Dawn's stepper would write that 3 straight onto
     the line quantity and bill three pairs, so these clicks are taken over
     here and answered with a variant swap instead — the line stays at quantity
     1 and moves to the tier that sells the asked-for count.

     Intercepting in the capture phase stops the event before it reaches the
     button's own listener, which is what keeps Dawn out of it. Delegated from
     the document because both cart surfaces re-render their rows wholesale.
     --------------------------------------------------------------------- */
  function tierSwap(stepper, wanted) {
    var tiers;
    try {
      tiers = JSON.parse(stepper.dataset.slTiers);
    } catch (error) {
      return null;
    }
    var from = parseInt(stepper.dataset.slVariant, 10);
    /* Below the smallest tier the shopper is asking for none of it. */
    if (wanted < 1) return { from: from, to: 0 };
    if (!tiers[wanted]) return null;
    return { from: from, to: tiers[wanted] };
  }

  function applySwap(swap) {
    var updates = {};
    updates[swap.from] = 0;
    if (swap.to) updates[swap.to] = 1;

    fetch(cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (updated) {
        /* An emptied cart still shows its old rows, and the gifts have just
           been detached behind them. */
        if (updated.item_count === 0) {
          window.location.reload();
          return;
        }
        /* Dropping to one machine also takes the second book back, so let the
           gift pass run and redraw once both changes have landed. */
        sync(true);
      })
      .catch(function () {
        /* Leave the cart as it was; the shopper can try the button again. */
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.quantity__button');
      if (!button) return;
      var stepper = button.closest('quantity-input[data-sl-tiers]');
      if (!stepper) return;

      var input = stepper.querySelector('input');
      var shown = parseInt(input.value, 10) || 0;
      var wanted = button.name === 'plus' ? shown + 1 : shown - 1;

      var swap = tierSwap(stepper, wanted);
      /* No tier sells that many: leave the box where it was rather than move
         the shopper to a count they did not ask for. */
      if (!swap) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      input.value = wanted;
      applySwap(swap);
    },
    true
  );

  sync();

  /* Dawn publishes cart-update after every add, quantity change and removal.
     Wrapped so the event object it passes is not read as forceRedraw — Dawn has
     already re-rendered by then. */
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      sync();
    });
  }

  /* Catches carts restored from the bfcache, where no cart-update ever fires. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });
})();
